<template>
    <div>
        <label for="input-text" class="form-label fw-semibold" style="font-size: 14px;">Contenu source</label>
        <textarea id="input-text" v-model="inputText" class="form-control"
            :class="{ 'is-invalid': inputText.length > config.input.maxLength }" :disabled="isLoading"
            placeholder="Saisissez ici le contenu à traduire…" rows="3" aria-label="Contenu à traduire"></textarea>
        <div class="d-flex justify-content-between align-items-center mt-2">
            <span :class="inputText.length > config.input.maxLength ? 'text-danger fw-semibold' : 'text-muted'">{{
                inputText.length }} / {{ config.input.maxLength }} caractère(s)</span>
        </div>
    </div>
</template>

<script>
import config from '../config/translator.config.js';
/**
 * Composant de saisie du texte à traduire.
 * Compatible v-model (prop 'value' + emit 'input').
 * Affiche un compteur de caractères (limite 200).
 *
 * @prop  {String}  value     - Texte courant (lié via v-model dans le parent).
 * @prop  {Boolean} isLoading - Désactive la saisie pendant une traduction.
 * @emits input               - Nouvelle valeur du texte à chaque frappe.
 */
export default {
    name: 'TranslatorTextInput',
    data() {
        return {
            /** Référence à la configuration globale du traducteur. */
            config
        }
    },
    props: {
        /** Valeur du texte, utilisée pour la liaison v-model. */
        value: {
            type: String,
            default: ''
        },
        /** Désactive la textarea pendant le chargement. */
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        /**
         * Proxy computed pour v-model :
         * - get : retourne la prop 'value'
         * - set : émet 'input' avec la nouvelle valeur
         */
        inputText: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    }
}
</script>
